import { DataSource } from "@angular/cdk/table";
import { BehaviorSubject } from "rxjs";
import { MatPaginator, MatSort } from "@angular/material";
import { Guid } from "guid-typescript";
import { HistoryOdataService } from "../../../services/history-odata.service";
import { WorkHistoryModel } from "../../../models/work-history.model";
import { OdataOptions } from "../../../services/odata-options";


export class OdataMatTableDataSource extends DataSource<WorkHistoryModel> {

    protected subject$ = new BehaviorSubject<WorkHistoryModel[]>([]) ;
    private orderby : { active:string, direction:string }  =  { active:"EventDate", direction:"desc"} ;

    protected _paginator: MatPaginator ;
    set paginator(paginator : MatPaginator | null) {
       this._paginator = paginator ;
       this._paginator.page.subscribe(
        x => {
          // {"previousPageIndex":0,"pageIndex":1,"pageSize":10,"length":100}
          this.update() ;
        }
      )
    }

    protected _sort: MatSort ;
    set sort(sort : MatSort | null) {
       this._sort = sort ;
       this._sort.sortChange.subscribe(
        ob => {
          // {active: "detail", direction: ""}
          this.orderby = ob ;
          this.update() ;
        }
      )
    }

    setWorkId(id : string):void {
      // if(id !== this.workId) {
        this.workId = id ;
        this.update() ;
      // }
    }

    protected loading$ = new BehaviorSubject<boolean>(false) ;
    get loadingEvents():BehaviorSubject<boolean> {
      return this.loading$ ;
    }

    constructor(private workId:string, private historyService : HistoryOdataService ) {
      super();
    }

    update() {
      if(!this.workId || !Guid.isGuid(this.workId) || this.workId.toString() === Guid.EMPTY) {
        this.subject$.next([]) ;
        return ;
      }

      let page = (this._paginator) ? this._paginator.pageIndex : 0 ;
      let pagesize = (this._paginator) ? this._paginator.pageSize : 10 ;
      let options: OdataOptions = {} ;

      // Setup orderby option if it's available
      let orderby = this.orderby ;
      if(orderby && orderby.direction && orderby.active) {
        options.orderby = `${orderby.active} ${orderby.direction}` ;
      }

      // Go get the data
      this.loading$.next(true) ;
      this.historyService.getHistory(this.workId, page || 0, pagesize || 10, options ).subscribe(
        frame => {
          this._paginator.length = frame.count ;
          this.subject$.next(frame.data) ;
          this.loading$.next(false)
        },
        error => {
          console.error(error) ;
          this.loading$.next(false)
        }
      ) ;
    }

    connect(): BehaviorSubject<WorkHistoryModel[]> {
      this.update() ;
      return (this.subject$) ;
    }

    disconnect() {}
  }

